var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-main"},[_c('div',{staticClass:"toast hide",staticStyle:{"margin":"0 auto"},attrs:{"id":"addCartToast"}},[_c('div',{staticClass:"toast-body"},[_c('div',[_c('i',{staticClass:"fas fa-check text-success"}),_c('br'),_vm._v(" คุณได้เพิ่มสินค้าไปในตะกร้าแล้ว ")])])])])
}]

export { render, staticRenderFns }